// Questo codice optional è usato per registrare un service worker.
// register() non verrà chiamato di default.

// Questo permette all'app di caricarsi più velocemente nelle visite successive e dà
// la capacità di lavorare offline.

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  // [::1] è l'indirizzo IPv6 localhost.
  window.location.hostname === '[::1]' ||
  // 127.0.0.0/8 sono considerati localhost per IPv4.
  window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

export function register(config) {
  if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    // Il costruttore di URL è disponibile in tutti i browser che supportano SW.
    // URL rimosso (inutilizzato)

    // Aggiungiamo un parametro di versione per evitare la cache
    const swUrl = `${process.env.PUBLIC_URL}/service-worker.js?${process.env.REACT_APP_VERSION || 'v1'}`;

    // Verifica se stiamo ricaricando per un aggiornamento forzato
    const isForcedReload = window.location.search.includes('forceRefresh=true');

    if (isForcedReload) {
      // Se è un ricaricamento forzato, pulisci la cache e ricarica
      if ('caches' in window) {
        caches.keys().then(cacheNames => {
          cacheNames.forEach(cacheName => {
            caches.delete(cacheName);
          });
        });
      }

      // Rimuovi il parametro dalla URL
      const cleanUrl = window.location.href.split('?')[0];
      window.history.replaceState({}, document.title, cleanUrl);
    }

    window.addEventListener('load', () => {
      if (isLocalhost) {
        // Questo è in esecuzione su localhost. Controlliamo se un service worker esiste ancora o meno.
        checkValidServiceWorker(swUrl, config);

        // Aggiunge alcuni log extra per localhost, puntando gli sviluppatori al
        // service worker/documentazione PWA.
        navigator.serviceWorker.ready.then(() => {
          console.log(
            'Questa app web sta usando un service worker in cache-first mode. ' +
            'Per saperne di più, visita https://cra.link/PWA'
          );
        });
      } else {
        // Non è localhost. Registra il service worker
        registerValidSW(swUrl, config);
      }
    });
  }
}

function registerValidSW(swUrl, config) {
  // Prima di registrare il service worker, assicuriamoci di non avere vecchie versioni
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(registrations => {
      for (let registration of registrations) {
        console.log('Unregistering old service worker:', registration);
        registration.unregister();
      }

      // Ora registriamo il nuovo service worker
      registerNewSW(swUrl, config);
    });
  } else {
    registerNewSW(swUrl, config);
  }
}

function registerNewSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      console.log('Service Worker registrato con successo:', registration);

      // Forza l'aggiornamento immediato del service worker
      registration.update().then(() => {
        console.log('Service Worker aggiornato');
      }).catch(error => {
        console.error('Errore durante l\'aggiornamento del Service Worker:', error);
      });

      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }

        installingWorker.onstatechange = () => {
          console.log('Service Worker state changed:', installingWorker.state);

          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // Nuovo contenuto disponibile
              console.log('Nuovo contenuto disponibile. Si prega di aggiornare la pagina.');

              // Esegui la callback di aggiornamento
              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }

              // Notifica l'utente tramite evento, NON fare reload automatico
              // Il reload verrà fatto dall'utente cliccando sul pulsante "Aggiorna"
              window.swRegistration = registration;
              window.dispatchEvent(new Event('swUpdated'));
              console.log('Nuova versione disponibile. L\'utente può aggiornare cliccando sul pulsante.');
            } else {
              // Il contenuto è stato memorizzato nella cache per l'uso offline
              console.log('Il contenuto è stato memorizzato nella cache per l\'uso offline.');

              // Esegui la callback di successo
              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };
    })
    .catch((error) => {
      console.error('Errore durante la registrazione del Service Worker:', error);
    });
}

function checkValidServiceWorker(swUrl, config) {
  // Controlla se il service worker può essere trovato. Se non può, ricarica la pagina.
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' },
  })
    .then((response) => {
      // Assicura che il service worker esista, e che stiamo ottenendo un file JS.
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        // Nessun service worker trovato. Probabilmente una app differente. Ricarica la pagina.
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        // Service worker trovato. Procedi normalmente.
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log('Nessuna connessione internet trovata. App in esecuzione in modalità offline.');
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}
